import axios from "axios";
import apiClient from "./axios-client";
import { getApiBaseUrl } from "../utils/helpers";

const BASE_URL = getApiBaseUrl();
/**
 * Define the async function to fetch menu data
 * @returns user details with menu
 */
export const getUserWithMenuDetails = async (userCode) => {
  const response = await apiClient.get(
    `${BASE_URL}/userdetails/get-user-menu?userCode=${userCode}`
  );
  return response.data;
};

/**
 * Define the async function to validate user
 * @returns user details
 */
export const validateUser = async (userName, password) => {
  const body = {
    userCode: userName,
    password: password,
  };
  const response = await axios.post(
    `${BASE_URL}/userdetails/validate-user-Password`,
    body,
    {}
  );
  return response.data;
};
/**
 * Define the async function to validate user OTP
 * @returns validation status as boolean
 */
export const validateOtp = async (userCode, otp) => {
  const body = {
    userCode: userCode,
    otp: otp,
  };
  const response = await axios.post(
    `${BASE_URL}/userdetails/verify-OTP`,
    body,
    {}
  );
  return response.data;
};

export const resendOtp = async (userCode) => {
  const body = {
    userCode: userCode,
  };
  const response = await axios.post(
    `${BASE_URL}/userdetails/resend-otp`,
    body,
    {}
  );
  return response.data;
};
